module.exports = __webpack_public_path__ + "assets/57e005a08d5ea030adb0acdac6fe8d10.png";